import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteQuestionResponseMutation, deleteQuestionResponseMutationVariables } from '../generated/deleteQuestionResponseMutation';
import { questionResponseFieldsFragment } from '../models/QuestionResponse';

/**
 * Get a callback to delete a QuestionResponse in the store.
 */
export function useDeleteQuestionResponseCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteQuestionResponseMutation, deleteQuestionResponseMutationVariables>(
        gql`
            mutation deleteQuestionResponseMutation ($id: ID!) {
                deleteQuestionResponse(id: $id) {
                    ...questionResponseFields
                }
            }

            ${questionResponseFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
